import { Affix } from 'antd';
import moment from 'moment';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import { DEFAULTDATEFORMAT } from '../../../common/constants';

const GracePeriodMessage = () => {
  const { getCurrentUser } = useContext(AppContext);
  const tenantUser = getCurrentUser()?.tenantUser;
  return (
    <Affix offsetTop="0">
      <dt className="grace-bar">
        <div className="grace-bar-text">
          Your subscription has expired and is in grace period. It will stop
          working on{' '}
          {moment(tenantUser?.tenant?.subscription?.validTill)
            .add(7, 'days')
            .format(DEFAULTDATEFORMAT)}
          .
        </div>
      </dt>
    </Affix>
  );
};

export default GracePeriodMessage;
